export enum OwnerUpdateStatus {
    NOT_UPDATED = 'NOT_UPDATED',
    UPDATE_SUCCESS = 'UPDATE_SUCCESS',
    UPDATE_FAILURE = 'UPDATE_FAILURE'
}
